<template>
    <div v-show="isShow" class="modal" :class="[`modal--${$options.name}`]">
        <div class="modal__close btn btn--remove" @click="close"></div>

        <div class="modal__title">Адрес доставки</div>

        <div class="deliveryModal__map" v-show="showDeliveryMap">
            <div class="deliveryMapAddress">
                <yandex-address-picker ref="geocoder" placeholder="Улица и дом" :bbox="$root.city.bbox" :city-name="$root.city.name" :map-value="$root.addr.formated"></yandex-address-picker>
            </div>

            <div v-if="$root.unavailableClientAddress.show === true" style="margin-top: 40px;margin-bottom: 20px;font-size: 20px;font-weight: 400;">
                <div style="margin-bottom: 20px;">
                    {{ $root.unavailableClientAddress.save ? 'Готово! Мы скажем, когда зона доставки расширится' : 'К сожалению мы пока не доставляем по вашему адресу'}}
                </div>
            </div>

            <div id="deliveryMap" class="deliveryMap" ref="map"></div>
        </div>

        <form @submit.prevent="saveDelivery" v-show="!showDeliveryMap">
            <label class="label--address" @click="showMap">
                <input type="text" v-model="$root.addr.formated" :data-empty="`${!$root.addr.formated}`" required>
                <span>Адрес доставки</span>
            </label>

            <template v-if="$root.unavailableClientAddress.show === false">
                <label class="label--room">
                    <input type="text" v-model="$root.addr.room" :data-empty="`${!$root.addr.room}`" required>
                    <span>Кв / Офис</span>
                </label>

                <label class="label--floor">
                    <input type="text" v-model="$root.addr.floor" :data-empty="`${!$root.addr.floor}`">
                    <span>Этаж</span>
                </label>

                <label class="label--entrance">
                    <input type="text" v-model="$root.addr.entrance" :data-empty="`${!$root.addr.entrance}`">
                    <span>Подъезд</span>
                </label>

                <label class="label--intercom">
                    <input type="text" v-model="$root.addr.intercom" :data-empty="`${!$root.addr.intercom}`">
                    <span>Домофон</span>
                </label>

                <button type="submit" class="btn btn--success">Подтвердить адрес</button>
            </template>
        </form>
    </div>
</template>

<script>
export default {
    name: 'select-delivery-address',

    data() {
        return {
            showDeliveryMap: false,
            map: null
        }
    },

    methods: {
        open() {
            this.$root.openModal(this.$options.name);
        },

        close() {
            this.$root.closeModal(this.$options.name);
            this.hideMap();
        },

        async showMap() {
            this.showDeliveryMap = true;

            if (this.map === null) await this.initMap();

            this.$nextTick(() => {
                this.map.container.fitToViewport();
            });
        },

        hideMap() {
            this.showDeliveryMap = false;
        },

        saveDelivery() {
            if (this.$root.addr.status !== 'delivered' && this.$refs['geocoder']) {
                let address = this.$refs['geocoder'].value;
                this.$root.addr.status = 'saving';
                this.$refs['geocoder'].getCoordinatesTheCustomerAddress(address);
                return false;
            }

            const save = {
                city_id: this.$root.city.id,
                address: this.$root.addr,
                requirements: this.requirements
            };

            this.$root.cacheStorage('set', 'orderType', 'delivery', new Date().getTime() + this.$root.cacheExpireDate);
            this.$root.cacheStorage('set', 'deliveryAddress', save);

            this.close();
        },

        navigateTo(coords, zoom = 15) {
            if (!this.map || !coords?.latitude || !coords?.longitude) return;

            if (this.map && coords.latitude) this.map.setCenter([ coords.latitude, coords.longitude ], zoom);

            const placemark = new ymaps.Placemark([ coords.latitude, coords.longitude ], {}, {
                iconLayout: 'default#image',
                iconImageHref: '/images/icons/map-pin--black.svg',
                iconOffset: [-15, -15],
                iconImageSize: [50, 50]
            });

            this.map.geoObjects.each((geoObject) => {
                if (geoObject.geometry.getType() === 'Point') this.map.geoObjects.remove(geoObject);
            });

            this.map.geoObjects.add(placemark);
        },

        searchDelivery(response) {
            this.$root.unavailableClientAddress.save = false;
            this.$root.addr = response;
            this.$root.addr.delivered = true;
            this.requirements = response.requirements;

            if (this.$root.addr.status !== 'saving') {
                if (!response.delivered) {
                    this.$root.addr.status = 'not_delivered';
                } else {
                    this.$root.addr.status = 'delivered';
                }
            }

            if (response.entrance !== null) {
                this.$root.addr.entrance = response.entrance;
            }

            if (this.$root.addr.status === 'saving' && response.delivered) {
                //уже сохраняется, нужно попытаться завершить если адрес входит в доставку
                this.$root.addr.status = 'delivered';
                this.saveDelivery();
            }
        },

        async initMap() {
            return new Promise((resolve) => {
                ymaps.ready(() => {
                    let coords = Object.values(this.$root.city.coord);
                    let isCityCoords = true

                    if (this.$root.addr.coordinates && this.$root.addr.coordinates.latitude && this.$root.addr.coordinates.longitude) {
                        isCityCoords = false
                        coords = [ this.$root.addr.coordinates.latitude, this.$root.addr.coordinates.longitude ]
                    }

                    this.map = new ymaps.Map(this.$refs.map, {
                        center: coords,
                        zoom: this.$root.city.mapZoom,
                        controls: [ 'geolocationControl', 'fullscreenControl', 'zoomControl' ],
                    });

                    this.map.events.add('click', (e) => this.getAddress(e.get('coords')));
                    this.map.geoObjects.events.add('click', (e) => this.getAddress(e.get('coords')));

                    if (!isCityCoords) {
                        this.getAddress(coords);
                    }
                    this.getDeliveryZones(ymaps, this.map, true);

                    resolve(this.map);
                });
            })
        },

        getAddress(coords) {
            ymaps.geocode(coords, { kind: 'house' }).then((res) => {
                const firstGeoObject = res.geoObjects.get(0);
                this.$root.addr.formated = firstGeoObject.properties.getAll().name;
            });

            const placemark = new ymaps.Placemark(coords, {}, {
                iconLayout: 'default#image',
                iconImageHref: '/images/icons/map-pin--black.svg',
                iconOffset: [-15, -15],
                iconImageSize: [50, 50]
            });

            this.map.geoObjects.each((geoObject) => {
                if (geoObject.geometry.getType() === 'Point') this.map.geoObjects.remove(geoObject);
            });

            this.map.geoObjects.add(placemark);
        },
    },

    computed: {
        isShow() {
            return this.$root.modal.open.name === this.$options.name;
        }
    }
}
</script>
